var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "justify-content-start mb-2" },
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        [
          _vm.hasBankStatementRequest
            ? _c("consolidated-request-bank-statements", {
                attrs: {
                  "bank-statements": _vm.bankStatements,
                  "is-multi-borrower-request": _vm.isMultiBorrowerRequest,
                  "expand-on-init": _vm.expandOnInit,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasDocumentsRequest
            ? _c("consolidated-request-documents", {
                attrs: {
                  "requested-documents": _vm.requestedDocuments,
                  "is-multi-borrower-request": _vm.isMultiBorrowerRequest,
                  "expand-on-init": _vm.expandOnInit,
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.hasApplicationShared
            ? _c("consolidated-request-application-shared", {
                attrs: {
                  "is-multi-borrower-request": _vm.isMultiBorrowerRequest,
                  "expand-on-init": _vm.expandOnInit,
                  "shared-applications": _vm.sharedApplications,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }